import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useOrderMetadata from '../../hooks/useOrderMetadata';
import showServerError from '../../helpers/showError';
import PatientModals from './PatientModals';
import { updateCanShowShimmer } from '../../redux_store/reducer/reducers/tableReducer/tableReducer';

const PatientActions = ({
                          reloadList,
                          orderPatientUuid,
                          setOrderPatientUuid,
                          openAssessmentModal,
                          toggleAssessmentModal,
                          openResourceModal,
                          toggleResourceModal,
                          openPatientEditModal,
                          togglePatientEditModal,
                          openProgramModal,
                          toggleProgramModal,
                        }) => {
  const dispatch = useDispatch();
  const { en: { titles, errors } } = useSelector((state) => state.i18n);
  const [searchParams, setSearchParams] = useSearchParams();
  const { accountUuid: paramAccountUuid } = useParams();

  const { loading: metadataLoading } = useOrderMetadata(
    orderPatientUuid,
    paramAccountUuid,
    () => {
      showServerError(dispatch, errors.noProvidersOnThisAccount);
      setOrderPatientUuid(null);
    },
    {
      actionTitle: titles.editPatient,
      actionCallback: () => {
        togglePatientEditModal(true);
      },
      callback: () => {
        setOrderPatientUuid(null);
      },
    },
  );

  return <PatientModals
    openPatientEditModal={openPatientEditModal}
    handleClosePatientEditModal={(shouldReloadList) => {
      if (shouldReloadList) {
        reloadList && reloadList();
      }
      togglePatientEditModal(false);
    }}
    openAssessmentModal={openAssessmentModal}
    handleCloseAssessmentModal={() => {
      toggleAssessmentModal(false);
      if (searchParams.has('q')) {
        searchParams.delete('q');
        const newParams: { [key: string]: string } = {};
        searchParams.forEach((value: string, key: string) => {
          newParams[key] = value;
        });
        setSearchParams(newParams);
      }
    }}
    openResourceModal={openResourceModal}
    handleCloseResourceModal={() => toggleResourceModal(false)}
    reloadData={() => {
      if (reloadList) {
        dispatch(updateCanShowShimmer(true));
        setTimeout(() => {
          reloadList(true);
        }, 500);
      }
    }}
    openProgramModal={openProgramModal}
    toggleProgramModal={() => toggleProgramModal(false)}
  />;
};

export default PatientActions;
